<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div class="Widget" v-if="widget">
    <aliveVideos
      :category="widget"
      :aspectRatio="'1_2'"
      :perPage="`xs-${mClass}slide-1 md-${mClass}slide-3 lg-${mClass}slide-4`"
      ga="Widget"
    />
  </div>
</template>
<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
// import get from 'lodash.get';
// import find from 'lodash.find';
import aliveVideos from './AliveVideos.vue';


export default {
  name: 'alive',
  data() {
    return {
      widget: false,
    };
  },
  components: {
    aliveVideos,
  },
  beforeDestroy() {
    document.querySelector('body').classList.remove('PageWidget');
    this.setWidgetMode(false);
  },
  beforeMount() {
    const self = this;
    document.querySelector('body').classList.add('PageWidget');
    this.loadWidget()
      .then((w) => {
        self.widget = w.data;
        if (self.singleV) {
          self.api.get(`/video/${self.singleV}`, {
            headers: {
              'x-tok-token': self.getToken,
              'Accept-Language': self.locale,
            },
          }).then(({ data }) => {
            self.getPI.muted(true);
            self.getPI.autoplay(true);
            self.loadTheVideo(data);
          });
        } else {
          self.appReady(true);
        }
      });
    return true;
  },
  methods: {
    ...mapMutations(['appReady', 'setMd', 'setLoginInfo', 'redirectToIP', 'setWidgetMode', 'refreshPageSizeInfo']),
    ...mapActions(['loadWidget', 'getMe', 'getPlans', 'playVideoById', 'loadTheVideo']),
  },
  computed: {
    ...mapGetters(['getPI', 'getToken']),
    ...mapState(['md', 'singleV', 'api', 'locale']),
    mClass() {
      try {
        return this.md.mobile() ? 'm-' : '';
      } catch (e) {
        return '';
      }
    },
  },
};
</script>
<style lang="scss">
#app{
  // min-height: unset;
}
.TokCategoryCarousel{
  border-bottom-width: 0;
}
.Widget{
  // background-color: #fff;
  @media (min-width: 1200px) {
    margin: 40px 5px;
  }
  .slide__title{
    margin: 0 5px;
    color: white;
  }
}
</style>
